module.exports = __webpack_public_path__ + "static/media/smileReaction.1050b047.svg";